export default "__VITE_ASSET__Bkqh7o1Y__"